<template>
    <div class="flex flex-col items-center justify-center w-full">
        <component
            ref="offersCH"
            v-for="(offerCard, index) in offersArray"
            :object="offerCard.object"
            :key="offerCard.key"
            :is="offerCard.model"
            v-on:remove="removeOffer($event, index)"
        />
        <base-add-button
            title="Ajouter un Produit / Service "
            @click="pushOfferCard"
        />
        <slot></slot>
        <wide-card title="Total CA (HT)" titleClass="text-center mb-2">
            <h2
                class="mr-6 text-sm font-extrabold leading-9 text-left text-blue-600 sm:text-lg sm:leading-10"
            >
                Total
            </h2>
            <div class="flex items-center w-full bg-gray-300">
                <h2 class="p-2 text-lg font-extrabold leading-9">
                    {{ totalCA }}
                </h2>
            </div>
        </wide-card>

        <wide-card
            v-if="!isSimplifiedVersion"
            title="CA à l’export"
            titleClass="text-center mb-2"
        >
            <h2
                class="mr-6 text-sm font-extrabold leading-9 text-left text-blue-600 sm:text-lg sm:leading-10"
            >
                Total
            </h2>
            <div class="flex items-center w-full bg-gray-300">
                <h2 class="p-2 text-lg font-extrabold leading-9">
                    {{ caExport }}
                </h2>
            </div>
        </wide-card>
    </div>
</template>

<script>
import OfferCard from "./OfferCard";
import WideCard from "@/components/cards/wideCard";
import { mapState, mapGetters } from "vuex";
import { scrollToError } from "@/mixins/scrollToMixin.js";

export default {
    props: {
        offersObject: {
            type: Array,
            required: true
        }
    },
    mixins: [scrollToError],
    components: {
        OfferCard,
        WideCard
    },
    data() {
        return {
            offersArray: this.offersObject
        };
    },

    methods: {
        pushOfferCard() {
            if (!this.checkForms()) {
                this.offersArray.push({
                    model: "offer-card",
                    key: new Date().getTime(),
                    object: {
                        id: new Date().getTime(),
                        options: "",
                        units: "",
                        price: null,
                        quantiteVente: null,
                        pourcentagePartExportee: null,
                        date: null,
                        isExported: false,
                        name: ""
                    }
                });
            } else {
                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
                this.scrollToError();
            }
        },
        removeOffer(payload, index) {
            this.offersArray.splice(index, 1);
            this.$store.dispatch("EtudeFinanciere/removeOffer", payload);
        },
        checkForms() {
            let formsHasError = false;
            this.$refs.offersCH.forEach(item => {
                if (!item.addCaDetails()) {
                    formsHasError = true;
                }
            });
            return formsHasError;
        }
    },
    computed: {
        ...mapGetters("user", {
            isSimplifiedVersion: "isSimplifiedVersion"
        }),
        ...mapState("EtudeFinanciere", {
            totalCA: state => {
                if (state.caDetails.type === "CA Détails")
                    return state.caDetails.offersObject.reduce(
                        (a, b) =>
                            a + parseInt(b.price) * parseInt(b.quantiteVente),
                        0
                    );
                return 0;
            },
            caExport: state => {
                if (state.caDetails.type === "CA Détails")
                    return state.caDetails.offersObject.reduce((a, b) => {
                        if (b.isExported)
                            return (
                                a +
                                (parseInt(b.price) *
                                    parseInt(b.quantiteVente) *
                                    parseInt(b.pourcentagePartExportee)) /
                                    100
                            );
                        return a;
                    }, 0);
                return 0;
            }
        })
    }
};
</script>

<style></style>
